import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function PublicFooter() {
  const { t } = useTranslation('landing');
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <svg
                className="w-8 h-8 text-blue-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span className="text-xl font-bold text-white">xtFORM</span>
            </div>
            <p className="text-sm">
              {t('footer.tagline', 'Build beautiful forms, surveys and live quizzes. Secure, powerful and easy to use.')}
            </p>
          </div>

          {/* Product Section */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.product', 'Product')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link className="hover:text-white transition-colors" to="/register">
                  {t('footer.getStarted', 'Get Started')}
                </Link>
              </li>
              <li>
                <a className="hover:text-white transition-colors" href="/#features">
                  {t('footer.features', 'Features')}
                </a>
              </li>
              <li>
                <a className="hover:text-white transition-colors" href="/#live-quiz">
                  {t('footer.liveQuiz', 'Live Quiz')}
                </a>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/docs/api">
                  {t('footer.apiDocs', 'API Documentation')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/blog">
                  {t('footer.blog', 'Blog')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions Section */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.solutions', 'Solutions')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link className="hover:text-white transition-colors" to="/education">
                  {t('footer.education', 'Education')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/business">
                  {t('footer.business', 'Business')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/events">
                  {t('footer.events', 'Events')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/demo/quiz">
                  {t('footer.demoQuiz', 'Demo Quiz')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/demo/poll">
                  {t('footer.demoPoll', 'Demo Poll')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.legal', 'Legal')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link className="hover:text-white transition-colors" to="/terms">
                  {t('footer.terms', 'Terms of Service')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/privacy">
                  {t('footer.privacy', 'Privacy Policy')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/cookies">
                  {t('footer.cookies', 'Cookie Policy')}
                </Link>
              </li>
              <li>
                <Link className="hover:text-white transition-colors" to="/about">
                  {t('footer.about', 'About Us')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center">
          <p>
            {t('footer.copyright', `© ${currentYear} xtFORM. All rights reserved.`, { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  );
}
